import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings";
import { SectionDescription } from "components/misc/Typography";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as LinkedinIcon } from "images/linkedin-icon.svg";
import { ReactComponent as GithubIcon } from "images/github-icon.svg";
import davidProfile from "images/david.png";
import hernanProfile from "images/hernan.png";
import jhonProfile from "images/jhon.png";
import larryProfile from "images/larry.png";

const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)``;
const Subheading = tw(SubheadingBase)`text-center mb-2`;
const Description = tw(SectionDescription)`mx-auto text-center`;

const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`;
const Card = tw.div`mt-8 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`;
const CardImage = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`w-64 h-64 bg-contain bg-center rounded`}
`;
const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-2 text-xl font-medium text-gray-900`}
  9
`;

const CardLinks = styled.div`
  ${tw`mt-2 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-primary-500 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`;

const getSocialLabel = (url, name) => {
  if (url.includes("linkedin.com")) return `Perfil de LinkedIn de ${name}`;
  if (url.includes("github.com")) return `Perfil de GitHub de ${name}`;
  return `Enlace social de ${name}`;
};

export default ({
  heading = "Conoce a nuestro equipo",
  subheading = "Nuestro equipo",
  description = "Jovenes apasionados por la tecnologia, el desarrollo y el aprendizaje continuo. Más de 10 años de experiencia en el sector tecnológico ofreciendo soluciones a nuestros clientes.",
  cards = [
    {
      imageSrc: davidProfile,
      position: "CO-FOUNDER",
      name: "David Villada",
      links: [
        {
          url: "https://www.linkedin.com/in/david-villada-luna-b173a813b/overlay/photo/",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com/kapumas",
          icon: GithubIcon,
        },
      ],
    },
    {
      imageSrc: hernanProfile,
      position: "CO-FOUNDER",
      name: "Hernan Restrepo",
      links: [
        {
          url: "https://twitter.com",
          icon: TwitterIcon,
        },
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com",
          icon: GithubIcon,
        },
      ],
    },
    {
      imageSrc: larryProfile,
      position: "CO-FOUNDER",
      name: "Larry Zamorano",
      links: [
        {
          url: "https://twitter.com",
          icon: TwitterIcon,
        },
        {
          url: "https://linkedin.com",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com",
          icon: GithubIcon,
        },
      ],
    },
    {
      imageSrc: jhonProfile,
      position: "Co-Founder",
      name: "Jhon Moofarrif",
      links: [
        {
          url: "https://linkedin.com/in/moofarrif",
          icon: LinkedinIcon,
        },
        {
          url: "https://github.com/moofarrif",
          icon: GithubIcon,
        },
      ],
    },
  ],
}) => {
  return (
    <Container id="team">
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage imageSrc={card.imageSrc} alt={`${card.name} - ${card.position}`} />
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a
                      key={linkIndex}
                      className="link"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={getSocialLabel(link.url, card.name)}
                    >
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
